import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fifth-meeting-second-step',
  templateUrl: './fifth-meeting-second-step.component.html',
  styleUrls: ['../../meeting-form.component.scss', '../form-steps.scss']
})
export class FifthMeetingSecondStepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
